// Free Waffle Chips Cart Logic for locaboca.in
document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const FREE_CHIPS_THRESHOLD = 5000 * 100; // Rs. 5000 in cents
  const WAFFLE_CHIPS_VARIANT_ID = '46805594636582'; // Waffle Chips variant ID
  const WAFFLE_CHIPS_PROPERTY = '_free_gift'; // Property to identify this as a free gift
  
  // Function to check cart and manage free gift
  async function manageWaffleChipsGift() {
    try {
      // Get current cart state
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Check if cart total meets threshold
      const cartTotal = cart.total_price;
      const hasWaffleChips = cart.items.some(item => 
        item.variant_id.toString() === WAFFLE_CHIPS_VARIANT_ID && 
        item.properties && 
        item.properties[WAFFLE_CHIPS_PROPERTY] === 'waffle_chips'
      );
      
      // Find any waffle chips that were manually added (without the free gift property)
      const manualWaffleChips = cart.items.find(item => 
        item.variant_id.toString() === WAFFLE_CHIPS_VARIANT_ID && 
        (!item.properties || !item.properties[WAFFLE_CHIPS_PROPERTY])
      );
      
      // If waffle chips were manually added, don't add another free one
      const hasManualWaffleChips = manualWaffleChips !== undefined;
      
      console.log("Cart Status:", {
        cartTotal,
        meetsThreshold: cartTotal >= FREE_CHIPS_THRESHOLD,
        hasWaffleChips,
        hasManualWaffleChips
      });
      
      // Add waffle chips if eligible but not already in cart (free or manual)
      if (cartTotal >= FREE_CHIPS_THRESHOLD && !hasWaffleChips && !hasManualWaffleChips) {
        console.log("Adding free waffle chips to cart");
        await addWaffleChips();
        
        // Add permanent notification in cart drawer if open
        if (document.getElementById('Cart-Drawer')) {
          addPermanentCartNotification();
        }
      } 
      // Remove free waffle chips if total below threshold but chips are in cart
      else if (cartTotal < FREE_CHIPS_THRESHOLD && hasWaffleChips) {
        const chipsItem = cart.items.find(item => 
          item.variant_id.toString() === WAFFLE_CHIPS_VARIANT_ID && 
          item.properties && 
          item.properties[WAFFLE_CHIPS_PROPERTY] === 'waffle_chips'
        );
        
        if (chipsItem) {
          console.log("Removing free waffle chips from cart");
          await removeWaffleChips(chipsItem.key);
          
          // Remove permanent notification from cart drawer if it exists
          const notification = document.querySelector('.waffle-chips-notification');
          if (notification) {
            notification.remove();
          }
        }
      }
      
      // If we have free waffle chips in the cart and the drawer is open, make sure notification is showing
      else if (hasWaffleChips && document.getElementById('Cart-Drawer')) {
        if (!document.querySelector('.waffle-chips-notification')) {
          addPermanentCartNotification();
        }
      }
    } catch (error) {
      console.error('Error managing free waffle chips:', error);
    }
  }
  
  // Function to add free waffle chips to cart
  async function addWaffleChips() {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            quantity: 1,
            id: WAFFLE_CHIPS_VARIANT_ID,
            properties: {
              [WAFFLE_CHIPS_PROPERTY]: 'waffle_chips',
              'Free Gift': 'Waffle Chips'
            }
          }]
        })
      });
      
      // Show notification immediately after successful add
      if (response.ok) {
        showNotification('Free Waffle Chips added to your cart!');
      }
      
      // Immediately trigger a cart refresh
      await forceCartRefresh();
      
      // Open the cart drawer to show the added product
      openCartDrawer();
    } catch (error) {
      console.error('Error adding waffle chips:', error);
    }
  }
  
  // Function to open the cart drawer
  function openCartDrawer() {
    // Check which method your theme uses to open the cart drawer
    console.log("Attempting to open cart drawer");
    
    // Method 1: Check if there's a cart drawer toggle
    const cartToggle = document.querySelector('.cart-drawer-toggle, [data-drawer-toggle="cart"], [aria-controls="Cart-Drawer"]');
    if (cartToggle && typeof cartToggle.click === 'function') {
      cartToggle.click();
      return true;
    }
    
    // Method 2: Check if the theme has a function to open cart
    if (typeof window.theme !== 'undefined') {
      // Dawn theme and derivatives
      if (typeof window.theme.openCartDrawer === 'function') {
        window.theme.openCartDrawer();
        return true;
      }
      
      // Expanse theme and others
      if (window.theme.CartDrawer && typeof window.theme.CartDrawer.open === 'function') {
        window.theme.CartDrawer.open();
        return true;
      }
    }
    
    // Method 3: Check if we have access to thb functions (your theme appears to use this)
    if (typeof window.thb !== 'undefined' && window.thb.themeFunctions) {
      if (typeof window.thb.themeFunctions.openCartDrawer === 'function') {
        window.thb.themeFunctions.openCartDrawer();
        return true;
      }
    }
    
    // Method 4: Many themes use side-panel or drawer classes
    const cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer) {
      // Try adding active class (common approach)
      cartDrawer.classList.add('active', 'open', 'is-open');
      
      // If there's an overlay, show it too
      const overlay = document.querySelector('.cart-drawer-overlay, .drawer-overlay');
      if (overlay) {
        overlay.classList.add('active', 'open', 'is-open');
      }
      
      return true;
    }
    
    return false;
  }
  
  // Function to remove free waffle chips from cart
  async function removeWaffleChips(itemKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });
      
      if (response.ok) {
        // Show notification about chips being removed
        showNotification('Free Waffle Chips removed from your cart');
      }
      
      // Immediately trigger a cart refresh
      await forceCartRefresh();
    } catch (error) {
      console.error('Error removing waffle chips:', error);
    }
  }
  
  // Function to force an immediate cart refresh
  async function forceCartRefresh() {
    // First try theme's native cart refresh methods
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
      return;
    } else if (window.thb && typeof window.thb.themeFunctions !== 'undefined' && typeof window.thb.themeFunctions.refreshCart === 'function') {
      window.thb.themeFunctions.refreshCart();
      return;
    } 
    
    try {
      // Otherwise, use Shopify AJAX API to update cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count display (common in most themes)
      const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, .cart-drawer-count');
      cartCountElements.forEach(el => {
        if (el) el.textContent = cart.item_count;
      });
      
      // Try theme's cart section refresh if available
      if (typeof window.theme !== 'undefined' && typeof window.theme.CartDrawer !== 'undefined') {
        if (typeof window.theme.CartDrawer.updateAllCartDrawerSections === 'function') {
          window.theme.CartDrawer.updateAllCartDrawerSections();
        }
      }
      
      // Update cart drawer content using section rendering API
      const sectionsResponse = await fetch('/?sections=cart-drawer,mini-cart,cart-icon-bubble');
      const sections = await sectionsResponse.json();
      
      // Find cart drawer elements and update them
      if (sections['cart-drawer']) {
        const drawerElement = document.getElementById('Cart-Drawer');
        if (drawerElement) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-drawer'];
          
          // Only replace the content, not the entire drawer
          const newContent = tempDiv.querySelector('.side-panel-content');
          const currentContent = drawerElement.querySelector('.side-panel-content');
          
          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
            
            // Reinitialize any JS components that might have been in the cart
            initializeCartComponents();
          }
          
          // Update footer if it exists
          const newFooter = tempDiv.querySelector('.side-panel-footer');
          const currentFooter = drawerElement.querySelector('.side-panel-footer');
          
          if (newFooter && currentFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          }
        }
      }
      
      // Update mini-cart if it exists
      if (sections['mini-cart']) {
        const miniCartElement = document.getElementById('mini-cart');
        if (miniCartElement) {
          miniCartElement.innerHTML = sections['mini-cart'];
        }
      }
      
      // Update cart bubble (common in many themes)
      if (sections['cart-icon-bubble']) {
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-icon-bubble'];
          const newBubble = tempDiv.querySelector('.cart-count-bubble');
          if (newBubble) {
            cartBubble.innerHTML = newBubble.innerHTML;
          }
        }
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
  
  // Initialize any JavaScript components in the cart drawer
  function initializeCartComponents() {
    // Re-initialize quantity selectors
    const quantitySelectors = document.querySelectorAll('.quantity.cart-update');
    if (quantitySelectors.length > 0) {
      if (typeof customElements !== 'undefined' && customElements.get('quantity-selector')) {
        // If a custom element is defined, it will auto-initialize
      } else {
        // Manual initialization
        quantitySelectors.forEach(selector => {
          const input = selector.querySelector('input');
          const plusBtn = selector.querySelector('.plus');
          const minusBtn = selector.querySelector('.minus');
          
          if (plusBtn && input) {
            plusBtn.addEventListener('click', () => {
              input.value = parseInt(input.value) + 1;
              input.dispatchEvent(new Event('change'));
            });
          }
          
          if (minusBtn && input) {
            minusBtn.addEventListener('click', () => {
              if (parseInt(input.value) > 1) {
                input.value = parseInt(input.value) - 1;
                input.dispatchEvent(new Event('change'));
              }
            });
          }
        });
      }
    }
    
    // Re-initialize remove buttons
    const removeButtons = document.querySelectorAll('.product-cart-item .remove');
    removeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        
        // Use fetch to remove item
        fetch(href, {
          method: 'GET',
          credentials: 'same-origin'
        }).then(() => {
          forceCartRefresh();
        });
      });
    });
    
    // Re-add the event listeners we set up earlier
    addQuantityListeners();
  }
  
  // Function to show notification
  function showNotification(message) {
    // First check if a notification container exists on the page
    let notification = document.getElementById('free-gift-notification');
    
    // If not, create one
    if (!notification) {
      notification = document.createElement('div');
      notification.id = 'free-gift-notification';
      notification.style.position = 'fixed';
      notification.style.bottom = '20px';
      notification.style.right = '20px';
      notification.style.backgroundColor = '#F68D61';
      notification.style.color = 'white';
      notification.style.padding = '10px 20px';
      notification.style.borderRadius = '5px';
      notification.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
      notification.style.zIndex = '9999';
      notification.style.transform = 'translateY(100px)';
      notification.style.opacity = '0';
      notification.style.transition = 'all 0.3s ease-out';
      notification.style.fontSize = '14px';
      notification.style.fontWeight = '500';
      document.body.appendChild(notification);
    }
    
    // Check if notification is already visible and clear any existing timeout
    if (notification.getAttribute('data-timeout')) {
      clearTimeout(parseInt(notification.getAttribute('data-timeout')));
    }
    
    // Update message and show notification
    notification.textContent = message;
    
    // Force a reflow to ensure the animation works even if called multiple times
    notification.offsetHeight;
    
    // Show the notification
    notification.style.transform = 'translateY(0)';
    notification.style.opacity = '1';
    
    // Hide after 4 seconds
    const timeout = setTimeout(() => {
      notification.style.transform = 'translateY(100px)';
      notification.style.opacity = '0';
    }, 4000);
    
    // Store the timeout ID as a data attribute
    notification.setAttribute('data-timeout', timeout);
  }
  
  // Function to create a permanent notification in the cart drawer
  function addPermanentCartNotification() {
    // Check if we're in the cart drawer context
    const cartDrawer = document.getElementById('Cart-Drawer');
    if (!cartDrawer) return;
    
    // Check if notification already exists
    if (cartDrawer.querySelector('.waffle-chips-notification')) return;
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = 'waffle-chips-notification';
    notification.innerHTML = `
      <div class="free-gift-message">
        <div class="free-gift-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#F68D61">
            <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <circle cx="15.5" cy="8.5" r="1.5"/>
            <circle cx="15.5" cy="15.5" r="1.5"/>
            <circle cx="8.5" cy="15.5" r="1.5"/>
            <circle cx="12" cy="12" r="1.5"/>
          </svg>
        </div>
        <span>Free Waffle Chips added to your cart!</span>
      </div>
    `;
    
    // Find where to insert it (after progress bar)
    const progressContainer = cartDrawer.querySelector('.shipping-rewards-wrapper');
    if (progressContainer && progressContainer.parentNode) {
      progressContainer.parentNode.insertBefore(notification, progressContainer.nextSibling);
    } else {
      // Fall back to the top of cart content
      const cartContent = cartDrawer.querySelector('.side-panel-content');
      if (cartContent && cartContent.firstChild) {
        cartContent.insertBefore(notification, cartContent.firstChild);
      }
    }
  }
  
  // IMPROVED: Monitor ajax requests and update cart after each change
  function interceptAjaxRequests() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(url, options) {
      // Call the original fetch
      const response = await originalFetch(url, options);
      
      // Clone the response to avoid consuming it
      const clonedResponse = response.clone();
      
      // Check if this is a cart-related request
      if (typeof url === 'string' && 
          (url.includes('/cart/add') || 
           url.includes('/cart/update') || 
           url.includes('/cart/change') ||
           url.includes('/cart/clear'))) {
        console.log("Cart operation detected:", url);
        
        // Wait for the response
        try {
          await clonedResponse.json();
          // Give a slight delay to allow Shopify to process
          setTimeout(manageWaffleChipsGift, 300);
        } catch (e) {
          console.error("Error processing fetch response:", e);
        }
      }
      
      return response;
    };
    
    // Also intercept XHR requests for older themes
    const originalOpen = XMLHttpRequest.prototype.open;
    
    XMLHttpRequest.prototype.open = function(method, url) {
      if (typeof url === 'string' && 
          (url.includes('/cart/add') || 
           url.includes('/cart/update') || 
           url.includes('/cart/change') ||
           url.includes('/cart/clear'))) {
        this.addEventListener('load', function() {
          console.log("XHR cart operation detected:", url);
          setTimeout(manageWaffleChipsGift, 300);
        });
      }
      
      return originalOpen.apply(this, arguments);
    };
  }
  
  // Listen for any form submit events to catch add to cart actions
  function listenForFormSubmissions() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      
      // Check if this is an add to cart form
      if (form.action && form.action.includes('/cart/add')) {
        console.log("Form submission detected to add to cart");
        
        // Delay slightly to let the cart update
        setTimeout(manageWaffleChipsGift, 500);
      }
    });
  }
  
  // Add event listeners for cart quantity changes
  function addQuantityListeners() {
    const quantitySelectors = document.querySelectorAll('.quantity.cart-update input');
    quantitySelectors.forEach(input => {
      // Remove any existing listeners to prevent duplicates
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);
      
      newInput.addEventListener('change', function() {
        console.log("Quantity changed, checking waffle chips status");
        // Add a small delay to ensure the cart is updated first
        setTimeout(manageWaffleChipsGift, 300);
      });
    });
    
    // Add event listeners for remove buttons
    const removeButtons = document.querySelectorAll('.product-cart-item .remove');
    removeButtons.forEach(button => {
      // Remove any existing listeners to prevent duplicates
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', function() {
        console.log("Item removed, checking waffle chips status");
        // Add a small delay to ensure the cart is updated first
        setTimeout(manageWaffleChipsGift, 300);
      });
    });
  }
  
  // Add listeners for add to cart buttons including AJAX buttons
  function addCartButtonListeners() {
    // Standard buttons
    const addToCartButtons = document.querySelectorAll('form[action="/cart/add"] button[type="submit"], .add-to-cart');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        console.log("Add to cart button clicked");
        // Wait for the cart to update, then check if we need to add free chips
        setTimeout(manageWaffleChipsGift, 600);
      });
    });
    
    // Quick add buttons and other AJAX buttons
    const quickAddButtons = document.querySelectorAll('[data-product-add], .quick-add, .js-ajax-submit');
    quickAddButtons.forEach(button => {
      button.addEventListener('click', function() {
        console.log("Quick add button clicked");
        // This might be an AJAX add, give it a bit more time
        setTimeout(manageWaffleChipsGift, 600);
      });
    });
  }
  
  // Fix potential race conditions with Shopify events
  function listenToShopifyEvents() {
    // Listen for Shopify events if they exist
    if (typeof Shopify !== 'undefined') {
      if (Shopify.onCartUpdate) {
        const originalOnCartUpdate = Shopify.onCartUpdate;
        Shopify.onCartUpdate = function() {
          originalOnCartUpdate.apply(this, arguments);
          console.log("Shopify.onCartUpdate fired");
          manageWaffleChipsGift();
        };
      }
      
      // Some themes use this event
      document.addEventListener('cart.requestComplete', function(event) {
        console.log("cart.requestComplete fired");
        manageWaffleChipsGift();
      });
    }
    
    // Listen for drawer events
    document.addEventListener('drawer:open', function(e) {
      if (e.detail && e.detail.drawer === 'cart') {
        console.log("Cart drawer opened");
        manageWaffleChipsGift();
      }
    });
  }
  
  // Monitor DOM changes to catch dynamically added elements
  function watchForDynamicElements() {
    // Create a mutation observer to watch for cart changes
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        // If nodes were added
        if (mutation.addedNodes.length > 0) {
          // Check if cart-related elements were added
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // If cart drawer is added
              if (node.id === 'Cart-Drawer' || 
                  node.classList.contains('cart-drawer') ||
                  node.querySelector('.cart-items')) {
                console.log("Cart-related element added to DOM");
                manageWaffleChipsGift();
                break;
              }
            }
          }
        }
      }
    });
    
    // Start observing the entire document
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
  
  // Initialize everything
  function init() {
    // Initial check
    manageWaffleChipsGift();
    
    // Set up all listeners
    addQuantityListeners();
    addCartButtonListeners();
    listenForFormSubmissions();
    interceptAjaxRequests();
    listenToShopifyEvents();
    watchForDynamicElements();
    
    // Standard Shopify events
    document.addEventListener('cart:updated', manageWaffleChipsGift);
    document.addEventListener('cart:refresh', manageWaffleChipsGift);
    
    // Recheck cart contents periodically
    setInterval(manageWaffleChipsGift, 3000);
    
    console.log("Free Waffle Chips logic initialized successfully");
  }
  
  // Start everything
  init();
});